import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { BalanceModel } from "src/app/models/balance-model";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { WithdrawalService } from "src/app/services/cashier/withdrawal.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { WithdrawalBaseComponent } from "../withdrawal-base/withdrawal-base.component";



@Component({
    selector: 'page-withdrawal-instadebit',
    templateUrl: 'withdrawal-instadebit.html',
    styleUrls: ['withdrawal-instadebit.scss']
})
export class WithdrawalInstaDebitPage extends WithdrawalBaseComponent implements OnInit {
    @ViewChild('Content') content: IonContent;

    public error = null;
    public btnDisabled = false;
    public hasAccount: boolean = false;
    public withdrawalForm: FormGroup;
    public amount: AbstractControl;
    public selectedAccount: AbstractControl;
    public customerAccountID: AbstractControl;
    public currency_code: AbstractControl;
    public payment_type_code: AbstractControl;
    public accounts: any = [];
    public accountBalances: BalanceModel;
    flatFee:number = 0;

    constructor(
        // private logger: Logger,
        private balanceProvider: AccountBalanceService,
        private navigator: Navigator,
        private withdrawService:WithdrawalService,
        private cashierProvider: CashierService,
        private events: EventsService,
        public utils:UtilsService,
        private successMessageService: SuccessMessageService) {

        super();

        this.successMessageService.clearMessage();
        this.error = null;
    }

    ngOnInit() {
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                customerAccountID: new FormControl(''),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
            }
        )
        this.amount = this.withdrawalForm.get('amount');
    }
    ionViewWillEnter() {
        this.onGetAccounts();
        this.withdrawService.getPayoutMethods().subscribe((res:any) =>{
            for(const paymentMethod of res){
                if(paymentMethod?.PAYMENT_TYPE?.code === 'INSTA'){
                    this.flatFee = paymentMethod?.FLAT_FEE;
                    break;
                }
            }
        })
    }
    ionViewDidLoad() {}
    ionViewDidEnter() {
        this.onGetBalance();

    }
    onGetBalance() {

        this.balanceProvider.getBalance().subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;
                }
            }
        );
        this.error = null;
    }
    onGetAccounts() {
        this.accounts = [];
        this.cashierProvider.callListAccounts().subscribe(
            (response) => {
                if (response.result) {
                    var tempAccounts: any = response.payload;
                    for (let index in tempAccounts) {
                        if (tempAccounts[index].paymentTypeCode == "INSTA") {
                            this.accounts.push(tempAccounts[index]);
                            this.hasAccount = true;
                        }
                    }
                }
                else {
                    // this.logger.error('Failed to get accounts');
                }
            }
        );
    }

    submit() {
        this.btnDisabled = true;
        setTimeout(() => { this.onWithdraw() }, 200);
    }

    onWithdraw() {
        this.btnDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;

        this.withdrawalForm.get("customerAccountID").setValue(this.accounts[0].customerAccountID);
        this.withdrawalForm.get("currency_code").setValue(this.cashierProvider.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("INSTA");

        this.withdrawService.callWithdraw(this.withdrawalForm.value).subscribe(
            (response: any) => {
                // this.logger.log("callWithdraw response = ", response);
                if (response && !!response.result ) {
                    // send the withdrawal event
                    let depositEventData = {
                        customerId: this.cashierProvider.customer.customerId,
                        amount:     this.withdrawalForm.get('amount').value
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData ), 2000);
                    this.amount.setValue('');

                    this.amount.markAsPristine();

                    this.successMessageService.setMessage('Your withdrawal request has been received.');

                    this.balanceProvider.updateBalance();

                    this.content.scrollToTop();
                }
                this.btnDisabled = false;
            },
            (error) => {
                this.btnDisabled = false;
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("callWithdraw error = ", error);
            }
        )

        this.error = null;
    }
}
